__turbopack_context__.v({
  "grid": "nine-block-grid-module-scss-module__9E5Qbq__grid",
  "gridContainer": "nine-block-grid-module-scss-module__9E5Qbq__gridContainer",
});
